export const dataNotReady = o =>
  !o.result || o.error || o.isCreate || !o.result.data

export const isInRequestingState = request => request.requesting
